function News(){

    this.build();
    barbaCallbacks.push(this);

}

News.prototype.build = function() {

    let $grid = $('.news-archive').isotope({
        itemSelector: '.grid-item',
        percentPosition: true,
        masonry: {
            // use outer width of grid-sizer for columnWidth
            columnWidth: '.grid-sizer',
            gutter: '.gutter-sizer',
            horizontalOrder: true
        }
    });

    document.addEventListener('lazyloaded', function (e) {
       $grid.isotope('layout');
    });

};